var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"question-result-tip"},[(_vm.isCorrect)?_c('image-base',{staticClass:"question-result-tip__correct",attrs:{"src":"/img/icon/student/study/result_correct.svg"}}):_c('image-base',{staticClass:"question-result-tip__wrong",attrs:{"src":"/img/icon/student/study/result_incorrect.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }